import React from 'react';
import Collapsible from 'react-collapsible';
import AddIcon from '@material-ui/icons/Add';
import CollapseIcon from '../../assets/images/collapse-collapsible.svg';
import { currencyFormatter } from '../../utils/methods';

interface CollapsibleBoxProps {
  text: string;
  open: boolean;
  id: string;
  sums: { mrc: number, total: number}
  table?: any;
  csvDownload: any;
  onCollapsibleNEClose: (id: string) => void;
  onCollapsibleNEOpen: (id: string) => void;
}

const CollapsibleBox: React.FC<CollapsibleBoxProps> = ({
  text, open, id, table, sums, onCollapsibleNEClose, onCollapsibleNEOpen, csvDownload,
}) => {
  // const formatRow = (price: number): string => {
  //   if (price < 0.01) return '';
  //   if (id === 'expense') {
  //     return `( $${currencyFormatter(price)} )`;
  //   }
  //   return `$${currencyFormatter(price)}`;
  // };
  // const trigger = (
  //   <div className="trigger-reports">
  //     <div onClick={() => {}}>
  //       <label>{text}</label>
  //       {csvDownload}
  //     </div>
  //     <div>
  //       <label style={{ marginRight: '10px' }}>{formatRow(sums.total)}</label>
  //       {open ? <img style={{ paddingBottom: '5px' }} src={CollapseIcon} alt="Collapse" /> : <AddIcon />}
  //     </div>
  //   </div>
  // );

  return (
    table
    // <Collapsible
    //   open={open}
    //   transitionTime={200}
    //   transitionCloseTime={150}
    //   trigger={trigger}
    //   onClosing={() => onCollapsibleNEClose(id)}
    //   onOpening={() => onCollapsibleNEOpen(id)}
    //   lazyRender={false}
    // >
    //   {table || <label>Not yet developed</label>}
    // </Collapsible>
  );
};

export default CollapsibleBox;
